import { generateShortUuid } from '../../../../../../../ag-common-svc/projects/ag-common-svc/src/shared/utils/generate-item-uuid';
import { FormItemGroup } from './form-item-group.model';

export enum FormRowKeys {
  id = 'id',
  order = 'order',
  colCount = 'colCount',
  caption = 'caption',
  itemGroups = 'itemGroups',
}

export class FormRow {
  [FormRowKeys.id]: string;
  [FormRowKeys.order]: number;
  [FormRowKeys.colCount]: number;
  [FormRowKeys.caption]: string;
  [FormRowKeys.itemGroups]: FormItemGroup[] = [];

  constructor(colCount = 1) {
    this[FormRowKeys.colCount] = colCount;
    this.id = generateShortUuid();
  }
}
